"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBoxGroup = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../../identity");

var form_base_1 = require("../form-base");

var checkbox_1 = require("./checkbox");

var CheckBoxGroup = function CheckBoxGroup(_a) {
  var id = _a.id,
      name = _a.name,
      legend = _a.legend,
      label = _a.label,
      options = _a.options,
      onChange = _a.onChange,
      _b = _a.theme,
      theme = _b === void 0 ? identity_1.ThemeLight : _b;
  return react_1["default"].createElement(form_base_1.FormBase, {
    label: label,
    htmlFor: id,
    legend: legend,
    theme: theme
  }, react_1["default"].createElement("fieldset", {
    id: id,
    name: name
  }, options.map(function (item) {
    return react_1["default"].createElement(checkbox_1.CheckBox, {
      key: item.value,
      value: item.value,
      label: item.label,
      checked: item.checked,
      onChange: onChange,
      theme: theme
    });
  })));
};

exports.CheckBoxGroup = CheckBoxGroup;